(function () {
  const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const numberFormatter = new Intl.NumberFormat('en-GB', {
    maximumFractionDigits: 2,
  });

  function safeNumber(value) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function calculate(values) {
    const spend = safeNumber(values.spend);
    const cpc = safeNumber(values.cpc);
    const conversionRate = safeNumber(values.conversionRate) / 100;
    const salePrice = safeNumber(values.salePrice);
    const leadToCustomerRate = safeNumber(values.leadToCustomerRate) / 100;

    const clicks = cpc > 0 ? spend / cpc : 0;
    const leads = clicks * conversionRate;
    const costPerLead = leads > 0 ? spend / leads : 0;
    const expectedRevenue = leads * salePrice * leadToCustomerRate;
    const expectedProfit = expectedRevenue - spend;
    const roiPercent = spend > 0 ? (expectedProfit / spend) * 100 : 0;

    return {
      clicks,
      leads,
      costPerLead,
      expectedRevenue,
      expectedProfit,
      roiPercent,
    };
  }

	
  function syncToForm(inputs) {
    // Maps calculator inputs to their corresponding CF7 field name attributes.
    const fieldMap = {
      'projected-monthly':  inputs.spend             || '',
      'expected-cpc':       inputs.cpc               || '',
      'target-rate':        inputs.conversionRate     || '',
      'average-sale-price': inputs.salePrice         || '',
      'lead-rate':          inputs.leadToCustomerRate || '',
    };

    Object.entries(fieldMap).forEach(function (entry) {
      const field = document.querySelector('.wpcf7 [name="' + entry[0] + '"]');
      if (field) field.value = entry[1];
    });
  }

  function updateResults(calculator) {
    const inputs = {};

    calculator.querySelectorAll('[data-ppc-input]').forEach((input) => {
      inputs[input.dataset.ppcInput] = input.value;
    });

    const results = calculate(inputs);

    const outputMap = {
      clicks: numberFormatter.format(results.clicks),
      leads: numberFormatter.format(results.leads),
      costPerLead: currencyFormatter.format(results.costPerLead),
      expectedRevenue: currencyFormatter.format(results.expectedRevenue),
      expectedProfit: currencyFormatter.format(results.expectedProfit),
      roiPercent: `${numberFormatter.format(results.roiPercent)}%`,
    };

    calculator.querySelectorAll('[data-ppc-output]').forEach((output) => {
      const key = output.dataset.ppcOutput;
      if (typeof outputMap[key] !== 'undefined') {
        output.textContent = outputMap[key];
      }
    });

    syncToForm(inputs);
  }

  function initCalculator(calculator) {
    const button = calculator.querySelector('[data-ppc-calculate]');
    const inputs = calculator.querySelectorAll('[data-ppc-input]');

    ['salePrice', 'leadToCustomerRate'].forEach((name) => {
      const input = calculator.querySelector(`[data-ppc-input="${name}"]`);
      if (input) input.setAttribute('step', '1');
    });

    if (button) {
      button.addEventListener('click', function () {
        updateResults(calculator);
      });
    }

    inputs.forEach((input) => {
      input.addEventListener('input', function () {
        updateResults(calculator);
      });
    });

    updateResults(calculator);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ppc-calculator]').forEach(initCalculator);
  });
})();
